import { defineNuxtPlugin } from "#app";

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.directive("drag-handle", {
    mounted(el: HTMLElement, binding) {
      const dragHandleSelector = binding.value.handle as string;
      const dragHandle = el.querySelector(
        dragHandleSelector
      ) as HTMLElement | null;
      const item = binding.value.item;

      const clearTextSelection = (event: DragEvent) => {
        if (window.getSelection) {
          window.getSelection().removeAllRanges();
        } else if (document.selection) {
          document.selection.empty();
        }
      };

      if (dragHandle) {
        dragHandle.addEventListener("mousedown", () => {
          el.setAttribute("draggable", "true");
        });

        el.addEventListener("dragstart", (event) => {
          clearTextSelection(event);
          el.classList.add("dragging");
          if (item && item.id) {
            const dataTransfer = event.dataTransfer;
            if (dataTransfer) {
              dataTransfer.setData("application/json", JSON.stringify(item));

              console.log("dragging", item.id);
            }
          }
        });

        el.addEventListener("dragend", () => {
          el.classList.remove("dragging");
          el.removeAttribute("draggable");
        });
      }
    },
  });
});
